import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminAddDriverComponent } from "../admin-add-driver/admin-add-driver.component";
import { AdminAddNotesComponent } from "../admin-add-notes/admin-add-notes.component";
import { AdminEditDriversComponent } from "../admin-edit-drivers/admin-edit-drivers.component";
import { AdminService } from "../admin.service";
import { CommonHelperComponent } from "../../common-helper/common-helper.component";

@Component({
  selector: "app-admin-drivers",
  templateUrl: "./admin-drivers.component.html",
  styleUrls: ["./admin-drivers.component.css"],
})
export class AdminDriversComponent implements OnInit {
  matDialogref!: MatDialogRef<AdminAddNotesComponent>;
  matDialogueView!: MatDialogRef<AdminEditDriversComponent>;
  matDialogueAdd!: MatDialogRef<AdminAddDriverComponent>;

  viewDriverStatus: number = 0;
  selectedDriverType: any = -1;
  SelectedNumber: number = 0;
  driverSelectedIds: any = [];
  token: any;
  DriverList: any = [];
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  total_cat_count: any;
  startPage: any = 1;
  last_page: any = 1;
  perPage: any = 10;
  searchButton: boolean = true;
  toggleSearch: boolean = false;
  driverNumber: any = -1;
  loading: boolean = false;
  addBtn: boolean = true;
  checkBox: boolean = false;
  DeleteAction: boolean = false;
  cancelDriver: boolean = false;
  deleteDriver: boolean = false;
  selectDriver: boolean = true;
  search_Btn: boolean = true;
  clear_Btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;

  @ViewChild("newItem") newItem: ElementRef;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private service: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.GetDrivers(this.driverNumber);
    // this.pagination(1);
    const savedPage = sessionStorage.getItem("lastDriverFetchPage");
    this.fetch_page = savedPage ? parseInt(savedPage) : 1;

    this.startPage = this.fetch_page;
    this.currentPage = this.fetch_page;
    let triptype = "drivers";
    localStorage.setItem("tripType", triptype);
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    if (this.previousValue.length > previousLength && this.clear_Btn) {
      this.callApi();
      this.search_Btn = true;
      this.clear_Btn = false;
    }

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.callApi();
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_Btn = true;
          this.clear_Btn = false;
        }
        break;
    }

    if (value.length > 10) {
      input.value = value.substring(0, 10);
      this.snackBar.open("Registration Number Limit Exceeded", "Fail", {
        duration: 5000,
      });
    }

    if (value.length === 0) {
      this.resetSearch();
    }
  }

  private callApi() {
    this.driverNumber = -1;
    this.fetch_page = 1;
    this.GetDrivers(this.driverNumber);
    this.fetch_page = 0;
    this.pagination(1);
  }
  getDriverList(selectedDriverType: any) {
    this.selectedDriverType = selectedDriverType;
    // this.GetDrivers(this.driverNumber);
    // Save tripType to localStorage
    localStorage.setItem("lastTripType", this.selectedDriverType);
    if (this.selectedDriverType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.GetDrivers(this.driverNumber);
      this.document_array = [];
    } else if (this.selectedDriverType == "requested") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.GetDrivers(this.driverNumber);
      this.document_array = [];
      this.DriverList = [];
    } else if (this.selectedDriverType == "available") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.GetDrivers(this.driverNumber);
      this.document_array = [];
    } else if (this.selectedDriverType == "allocated") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.GetDrivers(this.driverNumber);
      this.document_array = [];
    } else if (this.selectedDriverType == "rejected") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.GetDrivers(this.driverNumber);
      this.document_array = [];
    }
  }

  GetDrivers(type: any) {
    const order: 'asc' | 'desc' = 'desc';
    this.driverNumber = type;
    this.loading = true;
    this.service
      .driversGet(
        this.token,
        this.startPage,
        this.selectedDriverType,
        this.driverNumber,
        order
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.loading = false;
            this.DriverList = [];
            this.DriverList = response.body.data.data;
            this.document_array.push(response.body.data.meta);
            this.last_page = response.body.data.meta.lastPage;
          }
        },
        (error) => {
          this.loading = false;
          if (error.error.message == "Internal server error.!") {
            this.DriverList = [];
            this.snackBar.open("No records found", "Fail", {
              duration: 5000,
            });
            this.last_page = 1;
          }
          if (error.error.message === "No records found") {
            this.DriverList = [];
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message != "Internal server error.!") {
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        }
      );
  }

  public onSelect() {
    this.checkBox = true;
    this.search_Btn = false;
    this.searchButton = false;
    this.cancelDriver = false;
    this.deleteDriver = true;
    this.DeleteAction = false;
    this.selectDriver = false;
    this.addBtn = false;
    this.searchButton = false;
    this.toggleSearch = true;
    this.clear_Btn = true;
  }

  public matItem(event: any, item: any, index: number) {
    if (event.checked) {
      this.driverSelectedIds.push(item);
      this.SelectedNumber += 1;
    } else {
      this.driverSelectedIds.splice(index, 1);
      this.SelectedNumber -= 1;
      this.driverSelectedIds = [];
    }
  }

  public onSelectCancel() {
    this.driverNumber = -1;
    this.GetDrivers(this.driverNumber);
    this.driverSelectedIds = [];
    this.toggleSearch = false;
    this.searchButton = true;
    this.addBtn = true;
    this.selectDriver = true;
    this.checkBox = false;
    this.deleteDriver = false;
    this.DeleteAction = false;
    this.cancelDriver = false;
  }

  public onDelete() {
    if (this.SelectedNumber <= 0) {
      this.snackBar.open("Please select trucks to delete", "Fail", {
        duration: 5000,
      });
      return;
    } else {
      const dialogRef = this.matDialog.open(CommonHelperComponent, {
        data: {
          message: 'Are you sure you want to delete this record?'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          const deleteData = {
            ids: this.driverSelectedIds,
          };
          this.service.DeleteDriver(deleteData, this.token).subscribe(
            (response: any) => {
              if (response.status === 200 || response.status === 201) {
                this.onSelectCancel();
                this.snackBar.open("Driver deleted successfully", "Success", {
                  duration: 5000,
                });
                this.GetDrivers(this.driverNumber);
              }
            },
            (error) => {
              if (error.error.message === "jwt malformed") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "jwt expired") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              if (error.error.message === "invalid signature") {
                this.router.navigateByUrl("admin/login");
                window.localStorage.clear();
              }
              this.snackBar.open(error.error.message, "Fail", {
                duration: 5000,
              });
            }
          );
        }
      });
    }
  }

  public addDriver() {
    let matDialogueAdd = this.matDialog.open(AdminAddDriverComponent, {
      width: "80vw",
      height: "80vh",
      data: null,
      autoFocus: false,
    });
    matDialogueAdd.afterClosed().subscribe((res) => {
      this.GetDrivers(this.driverNumber);
    });
  }
  onInput(event: any): void {
    const input = event.target.value;
    event.target.value = input.replace(/[^0-9]/g, "");
  }

  public addNotes(driverId: any) {
    let matDialogref = this.matDialog.open(AdminAddNotesComponent, {
      width: "40vw",
      data: {
        _id: driverId,
        module_type: "driver",
      },
      autoFocus: false,
    });
    matDialogref.afterClosed().subscribe((res) => {
      this.GetDrivers(this.driverNumber);
    });
  }

  public viewDriver(item: any) {
    let matDialogueView = this.matDialog.open(AdminEditDriversComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    matDialogueView.afterClosed().subscribe((res) => {
      if (res?.success == "close") {
        this.GetDrivers(this.driverNumber);
        this.resetSearch();
      } else {
        this.GetDrivers(this.driverNumber);
        this.resetSearch();
      }
    });
  }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1); // Prevent negative pages
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1; // Set the first page correctly
    } else if (page_status == "last") {
      newPage = this.last_page || 1; // Ensure last page is fetched correctly
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    // Save current page to localStorage
    sessionStorage.setItem("lastDriverFetchPage", newPage.toString());

    this.GetDrivers(this.driverNumber);
  }

  openSearch() {
    this.search_Btn = true;
    this.clear_Btn = false;
    this.toggleSearch = true;
    this.searchButton = false;
    this.addBtn = false;
    this.cancelDriver = true;
    this.deleteDriver = true;
    this.selectDriver = false;
    this.checkBox = true;
    this.DeleteAction = true;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.driverNumber = -1;
    this.fetch_page = 1;
    this.GetDrivers(this.driverNumber);
    this.toggleSearch = false;
    this.searchButton = true;
    this.addBtn = true;
    this.selectDriver = true;
    this.checkBox = false;
    this.deleteDriver = false;
    this.DeleteAction = false;
    this.cancelDriver = false;
  }

  search(value: string) {
    if (value != "") {
      this.search_Btn = false;
      this.clear_Btn = true;
      this.startPage = 1;
      this.GetDrivers(value);
    }
  }
}
